import config from '../../../config';
import { authconfig } from '../../shared/utils/common';
import  axiosHttp from 'axios';
import { errorOccuredAndLogged_Mixpanel } from '../../shared/mixpanel/mixpanel';
import { CONNECTIVITY_ISSUE, NETWORK_ISSUE, NETWORK_ERROR, RETRIVE_MERCHANT_INFO_API, ONBOARDING_MERCHANTS_INFO_API, SUBMIT_CREATE_ACCOUNT_API, ONBOARDING_BUSINESS_INFO_API, APPROVE_ONBOARDING_BUSINESS_INFO_API, REJECT_ONBOARDING_BUSINESS_INFO_API } from '../../constants/mixPannelConstants';

export const retriveMerchantsInfo = async (data)=> {  // createaccount flow retrive merchants info
	let configs = authconfig(config.env, 'merchant');
	const { pageNum, pageSize, sortBy, sortOrder, aggregator, ...rest } = data;
	let url = `${process.env.MERCHANT_SERVICE_API}/merchants?pageNum=${pageNum}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
	if (aggregator) {
		url = `${process.env.MERCHANT_SERVICE_API}/merchants?pageNum=${pageNum}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&aggregator=${aggregator}`;
	}
	
	try {
		const response = await axiosHttp.get(url, { params: rest, ...configs });
		return response.data;
	}
	catch (error) {
		if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, RETRIVE_MERCHANT_INFO_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(error, RETRIVE_MERCHANT_INFO_API, CONNECTIVITY_ISSUE);
		}
		throw error;
	}
}

export const retriveViewLocationInfo = async (data)=> {  // View Location Details
	let configs = authconfig(config.env, 'merchant');
	const { brandId, ...rest } = data.payload;
	let url = `${process.env.MERCHANT_SERVICE_API}/merchants/stores/${brandId}`;
	
	try {
		const response = await axiosHttp.get(url, { params: rest, ...configs });
		return response.data;
	}
	catch (error) {
		if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, RETRIVE_MERCHANT_INFO_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(error, RETRIVE_MERCHANT_INFO_API, CONNECTIVITY_ISSUE);
		}
		throw error;
	}
}

export const onboardingMerchantsInfo = async ({data}) => { // to get onboard business details -bizdevflow landingpage
	let configs = authconfig(config.env, 'merchant');
	const { pageNum, pageSize, sortBy, sortOrder, ...rest } = data;
	let url = `${process.env.MERCHANT_SERVICE_API}/merchants/new/details?pageNum=${pageNum}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
	try {
		//const response = await axiosHttp.get(url, data, configs);
		const response = await axiosHttp.get(url, { params: rest, ...configs });
		return response.data;
	}
	catch (error) {
		if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, ONBOARDING_MERCHANTS_INFO_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(error, ONBOARDING_MERCHANTS_INFO_API, CONNECTIVITY_ISSUE);
		}
		throw error;
	}
}


export const submitCreateAccount = async(action)=> {
	let configs = authconfig(config.env, 'merchant');
	const { data } = action.payload ;
	let url = process.env.MERCHANT_SERVICE_API+`/merchants/accounts/new`;
	// console.log('CONFIG ', configs)
	
	try {
		const response = await axiosHttp.post(url, data, configs);
		return response.data;
	}
	catch (error) {
		if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, SUBMIT_CREATE_ACCOUNT_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(error, SUBMIT_CREATE_ACCOUNT_API, CONNECTIVITY_ISSUE);
		}
		return error;
	}
}
	

export const onboardingBusinessInfo = async(action)=> {   // to retrive businessinfo for bizdevflow form info-prefilled
	let configs = authconfig(config.env, 'merchant');
	const { businessId } = action.payload.data ;
	let url = process.env.MERCHANT_SERVICE_API+`/merchants/new/${businessId}`;
	
	try {
		const response = await axiosHttp.get(url, configs);
		return response.data;
	}
	catch (error) {
		if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, ONBOARDING_BUSINESS_INFO_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(error, ONBOARDING_BUSINESS_INFO_API, CONNECTIVITY_ISSUE);
		}
		throw error;
	}
}

export const ApproveOnboardingBusinessInfo = async(updatedBusinessInfo, id)=> {   // onboardbusiness approve call
	let configs = authconfig(config.env, 'merchant');
	const businessId  = id;
	let url = process.env.MERCHANT_SERVICE_API+`/merchants/new/${businessId}`;
	
	try {
		const response = await axiosHttp.put(url, updatedBusinessInfo, configs);
		return response.data;
	}
	catch (error) {
		if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, APPROVE_ONBOARDING_BUSINESS_INFO_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(error, APPROVE_ONBOARDING_BUSINESS_INFO_API, CONNECTIVITY_ISSUE);
		}
		throw error;
	}
}

export const RejectOnboardingBusinessInfo = async(statusupdatecall)=> {   // onboardbusiness reject call
	let configs = authconfig(config.env, 'merchant');
	const businessId  = (statusupdatecall.businessId);
	let status = '';
	
	 if (statusupdatecall.finalonbardingstatus) {
		 status = statusupdatecall.finalonbardingstatus;
	 }
	 else {
		status = 'NOT_ONBOARDED' 
	 }
	const onboardingStatus = {
		'onboardingStatus': status
	  }
	
	let url = process.env.MERCHANT_SERVICE_API+`/merchants/new/${businessId}`;
	
	try {
		const response = await axiosHttp.patch(url, onboardingStatus, configs);
		return response.data;
	}
	catch (error) {
		if (error?.message === NETWORK_ERROR) {
			errorOccuredAndLogged_Mixpanel(error, REJECT_ONBOARDING_BUSINESS_INFO_API, NETWORK_ISSUE);
		} else {
			errorOccuredAndLogged_Mixpanel(error, REJECT_ONBOARDING_BUSINESS_INFO_API, CONNECTIVITY_ISSUE);
		}
		throw error;
	}
}
